import styled from 'styled-components'
import { css, rgba, radiuses, colors, Link } from 'styles'

const StyledStatusPanel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 2rem;
  opacity: 0;
  box-sizing: border-box;
  text-transform: uppercase;
  font-size: 1rem;
  color: ${colors.mainInverted};
  transition: 0.3s;
  border-radius: 0 0 ${radiuses.large} ${radiuses.large};
  z-index: 2;

  .image-amount {
    display: flex;
    align-items: center;
    font-size: 1.2rem;

    i {
      margin-right: 0.5rem;
      color: ${colors.mainInverted};
    }
  }

  .member-hot {
    background: url(${p => require(`assets/icons/icon_hot${p.inHotlist ? '_active' : ''}.svg`)}) center center no-repeat;
    background-size: 1.5rem;
    width: 2.5rem;
    height: 3.6rem;
    margin-right: -1rem;
    &:hover {
      cursor: pointer;
      background-image: url(${p => require(`assets/icons/icon_hot_${!p.inHotlist ? '' : 'crossed_'}active.svg`)});
    }
  }
  .member-hot {
    ${({ vipEnabled }) =>
      vipEnabled &&
      css`
        background: url(${p => require(`assets/icons/icon_friend${p.inHotlist ? '_remove' : '_add'}.svg`)}) center
          center no-repeat;
        &:hover {
          ${p => css`
            background: url(${() => require(`assets/icons/icon_friend${p.inHotlist ? '_remove' : '_add'}.svg`)}) center
              center no-repeat;
            filter: invert(46%) sepia(77%) saturate(3319%) hue-rotate(0deg) brightness(103%) contrast(104%);
          `}
        }
      `}
  }
`

const StyledUserThumb = styled(Link)`
  margin-bottom: 4rem;
  text-decoration: none;

  .avatar {
    overflow: hidden;
    position: relative;
  }

  &:hover {
    ${StyledStatusPanel} {
      opacity: 1;
      background-color: ${rgba(colors.main, 0.8)};
    }

    .username-age {
      color: ${colors.highlight};
    }
  }

  &:hover .city-country {
    color: ${colors.textMain};
  }
`

const StyledUserInfo = styled.div`
  margin-top: 1.5rem;

  .username-age {
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0.1rem 0.4rem 0.1rem 0;
    font-weight: 600;
    font-size: 1.6rem;
    color: ${colors.textMain};
  }
  .username {
    margin-right: 0.5rem;
    padding-bottom: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .age {
    font-weight: 400;
  }
  .city-country {
    margin: 0;
    color: ${rgba(colors.textMain, 0.8)};
    font-size: 1.4rem;
    font-weight: 300;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /* Placeholder */
  .username-age:empty,
  .city-country:empty {
    width: 100%;
    background-color: rgba(214, 214, 214, 0.3);
    color: transparent;
    min-height: 2rem;
  }
  .username-age:empty {
    min-height: 2.2rem;
  }
  .city-country:empty {
    width: 70%;
  }
`

export default StyledUserThumb
export { StyledStatusPanel, StyledUserInfo }
